<template>
    <div :class="addr_info.id?'addresslist edit':'addresslist'">
        <van-nav-bar :title="addr_info.id?'地址修改':'新增地址'" left-text="返回" @click-left="onClickLeft"/>
        <van-address-edit
            :area-list="areaList"
            :show-delete="addr_info.id"
            :address-info="addr_info"
            show-set-default
            :show-area="false"
            :area-columns-placeholder="['请选择', '请选择', '请选择']"
            @save="onSave"
            @delete="onDelete"
            @change-detail="onChangeDetail"
        />
    </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import {AddressEdit, Toast} from 'vant';
import {areaList} from '@/area';

export default {
    name: "Bookmark",
    components: {Footer, "van-address-edit": AddressEdit},
    data() {
        return {
            searchResult: [],
            areaList,
            addr_info: {
                id: ""
            },
            item: {},
            url:""
        }
    },
    mounted() {

        this.url = (process.env.VUE_APP_baseURL).replace('smartCurtain/', '')
        let addr_info =window.location.hash.includes("item=")? JSON.parse(decodeURIComponent(window.location.hash).split("item=")[1].split("&")[0] || '{}'):{};
        this.addr_info = addr_info;
        this.addr_info.addressDetail = addr_info.street || addr_info.address;
        this.addr_info.tel = addr_info.tel || addr_info.phone;
        this.addr_info.isDefault = addr_info.default || addr_info.isDefault;
        
        // this.addr_info.areaCode = (addr_info.district_code || addr_info.areaCode||'') + '110101';
    },
    methods: {

        onClickLeft() {
            this.$router.replace('./addresslist?from='+this.$route.query.from+ '&isMianliao='+this.$route.query.isMianliao)
        },
        onSave(content) {
            if(content.id) {
                this.$http.put(this.url + "curtainOrder/customerAddress", {
                    isDefault: content.isDefault,
                    name: content.name,
                    mobile: content.tel,
                    id: content.id,
                    address: content.province + content.county + content.city + content.addressDetail,
                    nodata:true
                }).then(() => {
                    Toast('保存成功');
                    this.$router.replace('./addresslist?from='+this.$route.query.from+ '&isMianliao='+this.$route.query.isMianliao)
                })
                return
            }
            this.$http.post(this.url + "curtainOrder/customerAddress", {
                isDefault: content.isDefault,
                name: content.name,
                mobile: content.tel,
                address: content.province + content.county + content.city + content.addressDetail,
                nodata:true
                // province_code: content.areaCode.substr(0, 2) + '0000',
                // city_code: content.areaCode.substr(0, 4) + '00',
                // district_code: content.areaCode,
            }).then(() => {
                Toast('保存成功');
                this.$router.replace('./addresslist?from='+this.$route.query.from+ '&isMianliao='+this.$route.query.isMianliao)
            })
        },
        onDelete(content) {
            this.$http.post(this.url + "curtainOrder/deleteCustomerAddress", {
                default: content.isDefault,
                id: content.id,
                name: content.name,
                mobile: content.tel,
                address:  content.addressDetail,
                nodata:true
            }).then(() => {
                Toast('删除成功');
                this.$router.replace('./addresslist?from='+this.$route.query.from+ '&isMianliao='+this.$route.query.isMianliao)
            })


        },
        onChangeDetail(val) {
            if (val) {
                this.searchResult = [
                    {
                        name: '黄龙万科中心',
                        address: '杭州市西湖区',
                    },
                ];
            } else {
                this.searchResult = [];
            }
        },
    }
};
</script>

<style>

</style>
